import { connect } from 'react-redux';
import { createSelector, createStructuredSelector } from 'reselect';
import { SPECIAL_PRODUCT_TYPES } from 'swag-common/constants/product.constants';
import { getBoxProductDataForBoxBuilderPopup } from 'swag-client-common/utils/product.utils';
import { showPopup } from 'swag-client-common/redux/popup-manager/popup-manager.actions';
import { BOX_BUILDER_SELECT_PRODUCTS_DRAWER } from 'swag-client-common/constants';
import { saveColoredBoxInfo, saveEditedBoxItselfInfo, selectBackButton, selectColoredBoxInfo } from '../../../../../redux/box-builder/box-builder.actions';
import { STEPS } from '../../../../../redux/box-builder/box-builder.constants';
import { selectedOrExistedColoredBoxInfoSelector, isEditingBoxTypeBoxIdSelector } from '../../../../../redux/box-builder/box-builder.selectors';
import { specialBoxProductsSelector } from '../../../../../redux/cart/cart.selectors';
import ColoredBoxSelection from './colored-box-selection';
const selectedColorSelector = createSelector(selectedOrExistedColoredBoxInfoSelector, coloredBoxInfo => coloredBoxInfo === null || coloredBoxInfo === void 0 ? void 0 : coloredBoxInfo.color);
const currentBoxSelector = createSelector(specialBoxProductsSelector, specialProducts => specialProducts.find(product => product.specialProductType === SPECIAL_PRODUCT_TYPES.COLORED_BOX));
const mapStateToProps = createStructuredSelector({
  isBoxTypeEdit: isEditingBoxTypeBoxIdSelector,
  selectedColor: selectedColorSelector,
  selectedBoxData: createSelector(currentBoxSelector, currentBox => {
    // @todo. auto generated. fix this error
    // @ts-ignore
    return getBoxProductDataForBoxBuilderPopup(currentBox);
  }),
  colorsToChoose: createSelector(currentBoxSelector, currentBox => {
    if (!currentBox) {
      return [];
    }
    return currentBox.variants.filter(variant => !variant.isHidden).map(variant => {
      var _variant$images, _variant$images$front, _variant$images$front2;
      return {
        color: variant.color,
        name: variant.name,
        img: (variant === null || variant === void 0 ? void 0 : (_variant$images = variant.images) === null || _variant$images === void 0 ? void 0 : (_variant$images$front = _variant$images.front) === null || _variant$images$front === void 0 ? void 0 : (_variant$images$front2 = _variant$images$front[0]) === null || _variant$images$front2 === void 0 ? void 0 : _variant$images$front2.url) || currentBox.logo
      };
    });
  })
});
const mapDispatchToProps = dispatch => ({
  onNext: (boxColor, isEditMode) => {
    dispatch(saveColoredBoxInfo(boxColor));
    if (isEditMode) {
      dispatch(saveEditedBoxItselfInfo());
    } else {
      dispatch(showPopup({
        popup: BOX_BUILDER_SELECT_PRODUCTS_DRAWER
      }));
    }
  },
  onChange: boxColor => {
    dispatch(selectColoredBoxInfo(boxColor));
  },
  onBackButton: () => {
    dispatch(selectBackButton(STEPS.COLORED_BOX_SELECTION));
  }
});
export default connect(mapStateToProps, mapDispatchToProps)(ColoredBoxSelection);